export const PLACE_MODERATION_STATUS = Object.freeze({
  PENDING: "pending",
  APPROVED: "approved",
  REJECTED: "rejected",
});

export const getPlaceModerationStatus = place => {
  const explicit = place?.moderationStatus || place?.moderation_status;
  if (Object.values(PLACE_MODERATION_STATUS).includes(explicit)) return explicit;
  if (place?.metadata?.rejected) return PLACE_MODERATION_STATUS.REJECTED;
  if (place?.pending) return PLACE_MODERATION_STATUS.PENDING;
  return PLACE_MODERATION_STATUS.APPROVED;
};

export const isRejectedPlace = place => getPlaceModerationStatus(place) === PLACE_MODERATION_STATUS.REJECTED;
export const isPendingPlace = place => getPlaceModerationStatus(place) === PLACE_MODERATION_STATUS.PENDING;
export const isApprovedPlace = place => getPlaceModerationStatus(place) === PLACE_MODERATION_STATUS.APPROVED;
export const isQaFixturePlace = place => place?.metadata?.qa_fixture === true;

const moderationPlaceList = places => (Array.isArray(places) ? places : []).filter(place => !isRejectedPlace(place));

// User-facing discovery must never expose internal QA fixtures, even if the
// fixture is temporarily moved to approved while testing the Admin workflow.
export const publicPlaceList = places => moderationPlaceList(places).filter(place => !isQaFixturePlace(place));

// Admin moderation intentionally keeps QA fixtures visible so the complete
// pending -> approved workflow can be validated without touching real content.
export const pendingModerationPlaces = places => moderationPlaceList(places).filter(isPendingPlace);

export const approvedAdminPlaces = places => moderationPlaceList(places).filter(place => isApprovedPlace(place) && !!place?.addedBy);
